export const print = (title, features, body) => {
  // Crear un contenedor temporal
  const printContainer = document.createElement("div");
  printContainer.id = "printContainer";

  // Agregar el título al contenedor
  const titleElement = document.createElement("h1");
  titleElement.innerHTML = title;
  printContainer.appendChild(titleElement);

  // Agregar las características al contenedor
  const featuresElement = document.createElement("div");
  featuresElement.className = "features-container";
  featuresElement.innerHTML = `<p>FICHA</p>
      <ul>
        <li>- Porciones: ${features?.value?.portions}</li>
        <li>- Tiempo de preparación: ${
          features?.value?.preparationTime
        } minutos</li>
        <li>-
          Costo: 
          ${Array.from({ length: parseInt(features?.value?.cost) })
            .map(
              (_, index) => `<span> $ </span>`
            )
            .join("")}
        </li>
        ${
          features?.value?.calories
            ? "<li>- Calorías: " + features.value.calories + "</li>"
            : ""
        }
        ${
          features?.value?.cookingTime
            ? "<li>- Tiempo de cocción: " +
              features.value.cookingTime +
              " minutos</li>"
            : ""
        }
        ${
          features?.value?.drink
            ? "<li>- Bebida: " + features.value.drink + "</li>"
            : ""
        }
        ${
          features?.value?.typeOfCuisine
            ? "<li>- Tipo de cocina: " + features.value.typeOfCuisine + "</li>"
            : ""
        }
      </ul>`;
  printContainer.appendChild(featuresElement);

  // Agregar el contenido HTML al contenedor
  body.forEach((item) => {
    console.log(item)
    const contentElement = document.createElement("div");
    contentElement.style.pageBreakInside = "avoid";
    if(item.type === "ingredients") {
      contentElement.className = "body-container";
      contentElement.innerHTML = `
        <p class="title-ingredients">${item.title}</p>
        <ul>
          ${item.value.map(ingredient => `<li>${ingredient}</li>`).join("")}
        </ul>
      `;
    } else {
      contentElement.className = "body-container text";
      contentElement.innerHTML = item.value;
    }
    printContainer.appendChild(contentElement);
  });

  // Agregar el contenedor al DOM
  document.body.appendChild(printContainer);

  // Aplicar estilos CSS para ocultar el resto de la página durante la impresión
  const style = document.createElement("style");
  style.innerHTML = `
    @media print {      
      body > *:not(#printContainer) {
        display: none;
      }
        
      #printContainer, #printContainer * {
        visibility: visible;
      }
      #printContainer {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: auto;
        overflow: hidden;        
      }

      #printContainer h1 {
        text-align: center;
        width: 90%;
        padding-bottom: 7px;
        font-family: "ClarinvarVF";
        font-variation-settings: "wght" 400, "opsz" 66;
        margin-bottom: 25px;
      }
      
      .features-container {
        padding: 10px;
        margin: 30px 0 10px;
      }

      .features-container p {
        font-size: 11px;
        line-height: 25px;
        font-family: "AdelleSansClarin-VF";
        font-variation-settings: "wght" 600;
        color: #555555;
      }

      .features-container ul {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: transparent;
        -webkit-font-smoothing: antialiased;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: inherit;
        list-style-type: none;
        list-style: none;
      }

      .features-container ul li {
        font-size: 20px;
        line-height: 33px;
        font-family: "AdelleSansClarin-VF";
        font-variation-settings: "wght" 300;
        color: #000;
      }

      .text p {
        font-family: "ClarinvarVF";
        font-variation-settings: "wght" 400, "opsz" 66;
        color: #000;
        font-size: 23px;
        line-height: 33px;
        -webkit-letter-spacing: -0.12px;
        -moz-letter-spacing: -0.12px;
        -ms-letter-spacing: -0.12px;
        letter-spacing: -0.12px;
        padding: 17px 0;
      }

      .text h2 {
        font-family: "AdelleSansClarin-VF";
        font-variation-settings: "wght" 600;
        color: #000;
        font-size: 25px;
        line-height: 33px;
        -webkit-letter-spacing: -0.13px;
        -moz-letter-spacing: -0.13px;
        -ms-letter-spacing: -0.13px;
        letter-spacing: -0.13px;
        padding: 17px 0;
      }

      .text h3 {
        font-family: "ClarinvarVF";
        font-variation-settings: "wght" 700, "opsz" 66;
        margin: 0;
        font-size: 26px;
        line-height: 33px;
        -webkit-letter-spacing: -0.28px;
        -moz-letter-spacing: -0.28px;
        -ms-letter-spacing: -0.28px;
        letter-spacing: -0.28px;
        color: #000;
        padding-top: 17px;
        width: 100%;
        margin-bottom: 5px;
      }

      .body-container ul {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: transparent;
        -webkit-font-smoothing: antialiased;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: inherit;
        list-style-type: none;
        list-style: none;
      }

      .body-container ul li {
        font-size: 20px;
        line-height: 33px;
        font-family: "AdelleSansClarin-VF";
        font-variation-settings: "wght" 0;
        color: #000;
      }

      .body-container .title-ingredients {
        font-size: 11px;
        line-height: 25px;
        font-family: "AdelleSansClarin-VF";
        font-variation-settings: "wght" 600;
        color: #555555;
        text-transform: uppercase;
      }
    }
  `;
  document.head.appendChild(style);

  // Imprimir el contenido
  window.print();

  // Eliminar el contenedor temporal y los estilos
  document.body.removeChild(printContainer);
  document.head.removeChild(style);
};
